module.exports = __webpack_public_path__ + "img/box1_icon7.77124360.png";